import { lazy } from 'react'

export const BlockDictionaryLazy = lazy(() =>
    import('./BlockDictionary').then((component) => ({
        default: component.BlockDictionary,
    }))
)
